var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.264 3.52a5.25 5.25 0 0 1 6.41.73H10.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-1.5 0v1.204a6.75 6.75 0 1 0 2 4.796.75.75 0 0 0-1.5 0 5.25 5.25 0 1 1-7.986-4.48z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export default ForwardRef;